import { jsx as t } from "react/jsx-runtime";
import "../enums/file-type-enum.mjs";
import r from "../icons/audio-file-icon.mjs";
import i from "../icons/document-file-icon.mjs";
import a from "../icons/image-file-icon.mjs";
import m from "../icons/video-file-icon.mjs";
import { FileTypeEnum as e } from "@systemeio/types";
function u(o) {
  switch (o) {
    case e.Audio:
      return /* @__PURE__ */ t(r, { className: "fill-text-secondary", width: 40, height: 40 });
    case e.Image:
    case e.ImageOther:
      return /* @__PURE__ */ t(a, { className: "fill-text-secondary", width: 40, height: 40 });
    case e.Video:
      return /* @__PURE__ */ t(m, { className: "fill-text-secondary", width: 40, height: 40 });
    case e.Font:
    case e.Document:
      return /* @__PURE__ */ t(i, { className: "fill-text-secondary", width: 40, height: 40 });
    default:
      return /* @__PURE__ */ t(i, { className: "fill-text-secondary", width: 40, height: 40 });
  }
}
export {
  u as getThumbnailByType
};
